import LinkRoute, { LinkProps } from 'next/link'
import React, { FC } from 'react'

import {
  ListItemText,
  ListItem as MuiListItem,
  ListItemIcon,
  Link,
  SvgIconTypeMap
} from '@material-ui/core'
import { ListItemProps } from '@material-ui/core/ListItem'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import { useTheme } from '@material-ui/core/styles'
import { TypographyProps } from '@material-ui/core/Typography'

interface ListItemProp extends Partial<Omit<LinkProps, 'href'>> {
  icon?: OverridableComponent<SvgIconTypeMap>
  primary: string | JSX.Element
  secondary?: string
  listItemProps?: Omit<ListItemProps, 'button'>
  typographyProps?: TypographyProps
  href?: string
}

const ListItem: FC<ListItemProp> = ({
  icon: Icon,
  primary,
  secondary,
  href,
  listItemProps,
  typographyProps = {}
}) => {
  const theme = useTheme()
  const hrefIsValid = /(mailto:.*)|(tel:.*)|(http(s)?:.*)/gi.test(href)

  return (
    <MuiListItem dense disableGutters {...listItemProps}>
      {Icon && (
        <ListItemIcon style={{ minWidth: '35px' }}>
          <Icon color="secondary" fill={theme.palette.secondary.main} />
        </ListItemIcon>
      )}
      <ListItemText
        primaryTypographyProps={{
          color: 'inherit',
          variant: 'body1',
          ...typographyProps
        }}
        primary={
          href ? (
            <LinkRoute href={hrefIsValid ? href : `https://${href}`} passHref>
              <Link>{primary}</Link>
            </LinkRoute>
          ) : (
            primary
          )
        }
        secondary={secondary}
      />
    </MuiListItem>
  )
}

export default ListItem
